export const replaceTags = (str: string) => str.replaceAll(new RegExp(/<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g), '');
